import { gql, QueryHookOptions, useQuery } from '@apollo/client'

export interface ProcessedPage {
  id: string
  pageIndex: number
  pageNumber: number
  pageTitle: string
  pageUrl: string
}

interface GetProcessedPagesResponse {
  getProcessedPages: ProcessedPage[]
}

const GET_PROCESSED_PAGES_QUERY = gql`
  query GetProcessedPages($projectId: Int!, $reviewId: Int!) {
    getProcessedPages(projectId: $projectId, reviewId: $reviewId) {
      id
      pageIndex
      pageNumber
      pageTitle
      pageUrl
    }
  }
`

export const useProcessedPagesQuery = (
  projectId: number,
  reviewId: number,
  options?: QueryHookOptions
) => {
  const { data, loading, error, refetch } = useQuery<GetProcessedPagesResponse>(
    GET_PROCESSED_PAGES_QUERY,
    {
      variables: { projectId, reviewId },
      ...options
    }
  )

  return {
    processedPages: data?.getProcessedPages ?? [],
    loading,
    error,
    refetch
  }
}
